import { getArticleEditPageUrl } from 'src/services/pagesUrl/gerArticleEditPageUrl';

const getManageArticleUrl = (id: string) => getArticleEditPageUrl(id);

export default getManageArticleUrl;
